// src/components/GenericFilters.jsx
import { useState, useCallback } from 'react';
import { debounce } from '../utils/debounce';
import '../style/components/genericFilters.css';

const GenericFilters = ({
    onFilterChange,
    onClearFilters,
    searchPlaceholder = "Buscar...",
    showStatus = false,
    statusOptions = [],
    showDateRange = false,
    filterLabel = "Filtros"
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');

    const debouncedSearch = useCallback(
        debounce((term, status) => {
            onFilterChange({
                search: term,
                status: status || ''
            });
        }, 500),
        [onFilterChange]
    );

    const handleSearch = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        debouncedSearch(term, selectedStatus);
    };

    const handleStatusChange = (e) => {
        const status = e.target.value;
        setSelectedStatus(status);
        debouncedSearch(searchTerm, status);
    };

    const handleClear = () => {
        setSearchTerm('');
        setSelectedStatus('');
        setDateFrom('');
        setDateTo('');
        onClearFilters();
    };

    return (
        <div className="filters-container">
            <label>{filterLabel}</label>
            <div className="filters-content">
                <div className="filter-group">
                    <label>Buscar:</label>
                    <input
                        type="text"
                        placeholder={searchPlaceholder}
                        value={searchTerm}
                        onChange={handleSearch}
                        className="search-input"
                    />
                </div>

                {showStatus && (
                    <div className="filter-group">
                        <label>Estado:</label>
                        <select
                            value={selectedStatus}
                            onChange={handleStatusChange}
                            className="filter-select"
                        >
                            {statusOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                )}

                {showDateRange && (
                    <>
                        <div className="filter-group">
                            <label>Desde:</label>
                            <input
                                type="date"
                                value={dateFrom}
                                onChange={(e) => setDateFrom(e.target.value)}
                                className="filter-input"
                            />
                        </div>
                        <div className="filter-group">
                            <label>Hasta:</label>
                            <input
                                type="date"
                                value={dateTo}
                                onChange={(e) => setDateTo(e.target.value)}
                                className="filter-input"
                            />
                        </div>
                    </>
                )}

                {(searchTerm || selectedStatus || dateFrom || dateTo) && (
                    <button
                        onClick={handleClear}
                        className="filter-btn"
                    >
                        Limpiar
                    </button>
                )}
            </div>
        </div>
    );
};

export default GenericFilters;